document.addEventListener('DOMContentLoaded', async () => {
//     const resultsContainer = document.getElementById('resultsContainer2');
//   resultsContainer.innerHTML = '';
    const apiEndPoint = "acsautoapi.azurewebsites.net";
    // const apiEndPoint = "localhost:44370";

      // Function to get the value of a cookie by name
      function getCookieValue(cookieName) {

        const cookieString = document.cookie;
        const cookies = cookieString.split(';');
        for (const cookie of cookies) {
          const [name, value] = cookie.trim().split('=');
          if (name === cookieName) {
            return value != "undefined" ? value : null;
          }
        }
        return null;
      }
    // Function to show loading spinner
    function showLoading() {
        const loadingSpinner = document.getElementById('loadingSpinner2');
        loadingSpinner.style.display = 'block';
    }

    // Function to hide loading spinner
    function hideLoading() {
        const loadingSpinner = document.getElementById('loadingSpinner2');
        loadingSpinner.style.display = 'none';
    }
    // Consolidated fetch function with error handling
    async function fetchApiData(url, options = {}) {
        try {
            const response = await fetch(url, {
                headers: {
                    'xuserid': getCookieValue('xuserid')
                  },
                credentials: 'include',
                ...options,
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const responseData = await response.json();
            // Set the 'xuserid' cookie with the value from the response
            document.cookie = `xuserid=${responseData.xuserid}; path=/`;
          
            return responseData;
        } catch (error) {
            throw new Error(`Error during fetch: ${error.message}`);
        }
    }

    // Functions for Rego and VIN searches
    async function regoSearch(state, rego) {
        const url = `https://${apiEndPoint}/AutoInfoSearch/VehicleByLicencePlateD?Licenceplate=${rego}&State=${state}`;
        return await fetchApiData(url);
    }

    async function vinSearch(vin) {
        const url = `https://${apiEndPoint}/AutoInfoSearch/SearchByVinNumber?vinString=${vin}`;
        return await fetchApiData(url);
    }

    // Function to render vehicles table
    function renderVehiclesTable(vehicles, searchType) {
        const container = document.getElementById('resultsContainer2');

        container.innerHTML = '';
    
        // Create the table element
        const table = document.createElement('table');
        table.classList.add('table', 'table-striped'); // Example classes for styling
    
        // Create the table header
        if (vehicles.length > 0) {
            const headerRow = table.insertRow();
            const headerCells = ['Vehicle Description', 'Actions']; // Add 'Actions' for the button
            headerCells.forEach(header => {
                const headerCell = headerRow.insertCell();
                headerCell.textContent = header;
            });
    
            // Create rows for each vehicle
            vehicles.forEach(vehicle => {
                const row = table.insertRow();
    
                const makeCell = row.insertCell();
                makeCell.textContent = vehicle.vehicleLongDescription;
    
                // Create the 'Select' button cell
                const actionCell = row.insertCell();
                const selectButton = document.createElement('button');
                selectButton.textContent = 'Select';
                selectButton.classList.add('btn', 'btn-primary'); // Example button classes
                actionCell.appendChild(selectButton);
    
                // Add click event listener to the 'Select' button
                selectButton.addEventListener('click', () => {
                    showLoading();
                    const apiUrl = `https://${apiEndPoint}/AutoInfoSearch/GetSearchResultsByKey?vehicleId=${vehicle.vehicleIdEncrypted}`;
                    fetchApiData(apiUrl)
                        .then(data => {
                            if (data) {
                                // Populate the page with fetched data
                                document.getElementById('vehicle-search-result').style.display = 'none';
                                populatePageWithData(data.model, 'resultsContainer2');
                                // Show the result div
                                document.getElementById('resultDiv').style.display = 'block';
                                // Hide the no parts found message
                                document.getElementById('noPartsFound2').style.display = 'none';
                            } else {
                                // Show the no parts found message
                                document.getElementById('noPartsFound2').style.display = 'block';
                                // Hide the result div
                                document.getElementById('resultDiv').style.display = 'none';
                            }
                            hideLoading();
                        });
    
                    // Highlight the selected row
                    const rows = table.querySelectorAll('tr');
                    rows.forEach(row => row.classList.remove('selected'));
                    row.classList.add('selected');
    
                    console.log('Vehicle selected:', vehicle);
                });
            });
    
            // Append the table to the container
            container.appendChild(table);
            container.style.display = "block";
    
            // Add the "clickable-row" class to body rows for cursor change
            const bodyRows = table.querySelectorAll('tr:not(:first-child)');
            bodyRows.forEach(row => row.classList.add('clickable-row'));
        } else {
            document.getElementById('noPartsFound2').style.display = 'block';
            // Hide the result div
            document.getElementById('resultDiv').style.display = 'none';
        }
    }
    

    // Function to handle search button click
    document.getElementById('searchButton').addEventListener('click', async () => {
        document.getElementById('noPartsFound2').style.display = 'none';

       
        // Hide the result div
        document.getElementById('resultDiv').style.display = 'none';
        resetResults();
        showLoading();
        const regoNo = document.getElementById('regoNo').value.trim();
        const regoState = document.getElementById('regoStateAU').value.trim();
        const vinNo = document.getElementById('vinNo').value.trim();

        try {
            if (regoNo && regoState) {
                const apiResult = await regoSearch(regoState, regoNo);
                handleApiResult(apiResult, "rego");
            } else if (vinNo) {
                const apiResult = await vinSearch(vinNo);
                handleApiResult(apiResult, "vin");
            } else {
                showError('Please provide either Rego no. and State or VIN no.');
            }
            hideLoading();
        } catch (error) {
            hideLoading();
            showError(error.message); // Display specific error message
            console.error(error);
        }
    });

    // Function to reset results and errors
    function resetResults() {
        const container = document.getElementById('vehicle-search-result');
        container.innerHTML = '';
    }

    // Function to handle API result
    function handleApiResult(apiResult, searchType) {
        //console.log("Result", apiResult);
        if (Array.isArray(apiResult.vrqResult)) {
           // if(apiResult.vrqResult.length>1)
            renderVehiclesTable(apiResult.vrqResult, searchType);
        // if(apiResult.vrqResult.length==1){
        //     const apiUrl = `https://${apiEndPoint}/AutoInfoSearch/GetSearchResultsByKey?vehicleId=${apiResult.vrqResult[0].vehicleIdEncrypted}`;
        //     window.open(apiUrl, '_blank');   
        // }
        
        } else {
            showError('Invalid API response format.');
        }
    }

      document.getElementById('rresetId').addEventListener('click', function ()  {
        const regoNo = document.getElementById('regoNo');
        const regoState = document.getElementById('regoStateAU');
        const vinNo = document.getElementById('vinNo');
        regoNo.value = '';
        regoState.selectedIndex = 0;
        vinNo.value = '';
        const resultsContainer = document.getElementById('resultsContainer2');
        const container = document.getElementById('vehicle-search-result');
        container.innerHTML='';
        resultsContainer.innerHTML = '';
    })
    // Function to show error message
    function showError(message) {
        const container = document.getElementById('vehicle-search-result');
        container.innerHTML = `<p>${message}</p>`;
    }
});
